import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import { gql, useMutation } from '@apollo/client';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useForm, Controller } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { yupResolver } from '@hookform/resolvers/yup';
import * as React from 'react';
import * as yup from 'yup';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(10, 0),
  },
  text: { color: theme.motorX.darkGray },
  separator: {
    borderRadius: 0,
    borderTop: `10px solid ${theme.palette.secondary.main}`,
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(4),
    border: `2px solid ${theme.palette.secondary.main}`,
    backgroundColor: theme.palette.primary.main,
    color: theme.motorX.lightGray,
  },
  progress: {
    color: theme.motorX.lightGray,
    backgroundColor: theme.motorX.lightGray,
  },
}));

const CssTextField = withStyles((theme) => ({
  root: {
    '& label.Mui-focused': {
      color: theme.motorX.gray,
    },
    '& .MuiOutlinedInput-root': {
      color: theme.motorX.gray,
    },
    '& .MuiOutlinedInput': {
      borderColor: theme.motorX.gray,
    },
    '& .MuiOutlinedInput-input:after': {
      borderColor: theme.palette.secondary.main,
    },
    '& .MuiOutlinedInput-input': {
      border: `1px solid ${theme.motorX.darkGray}`,
    },
    '&.MuiOutlinedInput-input': {
      borderColor: theme.palette.secondary.main,
    },
    '& .MuiOutlinedInput-colorSecondary': {
      color: theme.palette.secondary.main,
    },
    '& .Mui-focused': {
      border: `1px solid ${theme.motorX.darkGray}`,
    },
    '& .MuiInputLabel-outlined': {
      color: theme.motorX.darkGray,
    },
  },
}))(TextField);

const ADD_SUBSCRIBER = gql`
  mutation AddSubscriberMutation($email: EmailAddress!) {
    addSubscriber(email: $email) {
      id
      email
      tags
      createdAt
      updatedAt
    }
  }
`;

const schema = yup
  .object({
    email: yup
      .string()
      .email('El correo electrónico es incorrecto.')
      .required('Es necesario un correo electrónico para continuar.'),
  })
  .required();

const Newsletter = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [addSuscriber, { loading, error }] = useMutation(ADD_SUBSCRIBER);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty, isValid },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async ({ email }) => {
    await addSuscriber({ variables: { email } });

    if (!error) {
      reset({ email: '' });

      enqueueSnackbar(`Muchas gracias por subscribirte ${email}.`, {
        variant: 'success',
      });
    }
  };

  return (
    <Grid item lg={4}>
      <Typography gutterBottom variant="h6" className={classes.text}>
        Únete a nosotros
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Box component="div" display="flex">
          <Controller
            name="email"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <CssTextField
                {...field}
                variant="outlined"
                label="Correo electrónico..."
                color="secondary"
                error={errors?.email}
                helperText={errors?.email?.message}
              />
            )}
          />
        </Box>

        <Box component="div" display="flex">
          <Button
            className={classes.button}
            variant="contained"
            style={{ color: 'white' }}
            disabled={isDirty && !isValid}
            type="submit"
            startIcon={loading ? <CircularProgress size={24} /> : null}
          >
            {loading ? 'Enviando...' : 'Enviar'}
          </Button>
        </Box>
      </form>
    </Grid>
  );
};

export default Newsletter;
